import { api } from './api';

const addressGetList = async (params) => {
    const response = await api({
        url: `Addresses/GetList`,
        method: 'GET',
        params,
    });
    return response.data;
};

const addressGetPagedListByUserQuery = async ({ pageNumber = 1, pageSize = 10, customerId, ...data }) => {
    const req = {
        //page: pageNumber,
        //pageSize,
        customerId,
        ...data.data,
    }
    const response = await api({
        url: `Addresses/GetAddressesByUserRoleQuery`,
        method: 'POST',
        headers: {
            'x-skip-loader': true,
        },
        params: null,
        data:req,
    });
    return response.data;
};

const addressGetListByUserQuery = (customerId) => {
    return addressGetPagedListByUserQuery({ customerId });
};

const addressUpdate = async (data) => {
    const response = await api({
        url: `Addresses/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const addressSave = async (data) => {
    const response = await api({
        url: `Addresses/add`,
        method: 'POST',
        data,
    });
    return response.data;
};

const addressDelete = async (data) => {
    const response = await api({
        url: `Addresses/delete`,
        method: 'POST',
        params: {
            customerId: window.customerId
        },
        data: {
            ...data,
            customerId: window.customerId
        },
    });
    return response.data;
};

const getListAddresses = ({ data, vouId }) => {
    return addressGetList({
        ...data,
        Page: data.PageNumber
    })
};

const addressServices = {
    addressSave,
    addressGetList,
    addressDelete,
    addressUpdate,
    addressGetPagedListByUserQuery,
    addressGetListByUserQuery,
    getListAddresses,
};

export default addressServices;
